import React, { useCallback, useEffect, useReducer, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import { useViewConsumptionQuery } from '../../../store/auth/authService';
import { Spinner, Typography } from '@material-tailwind/react';
import FiltersConsumption from './FiltersConsumption';
import GraphConsumption from './GraphConsumption';
import TableLayout from '../../../layouts/pagesLayouts/TableLayout';
import { useTranslation } from 'react-i18next';
import { isIterableArray, saveGraphToPicture, toFormatPrice } from '../../../utils/utils';
import { classCharWithDoughtnutContainerHeight, isData, isShowInLegend } from '../common';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import ViewByPeriodDetailing from '../viewDoughnutByPeriod/ViewByPeriodDetailing';
import axios from 'axios';
import { baseApi } from '../../../ConfigApi';
import { errorToast } from '../../../components/toasts/toasts';
import fileDownload from 'js-file-download';
import { chartColors } from '../../../utils/variables';
import { ConsFormType } from '../common.types';


const GRAPH_ID = "js-cons-by-period-graph"
const GRAPH_DOUGH_PRICE_ID = "js-dough-consumprtion-period-graph"
const GRAPH_DOUGH_TARIF_ID = "js-dough-consumprtion-period-graph"

const ViewByPeriod = ({ setPeriodMonth, periodMonth, isMobile, activeDateCommon }: {
    activeDateCommon: any,
    setPeriodMonth: any,
    periodMonth: string,
    isMobile: boolean,
}) => {

    const { t } = useTranslation()

    const { param_contract_id } = useParams<{
        param_contract_id: string;
    }>()

    const { token } = useSelector((state: RootState) => state.auth)
    const { or_number } = useSelector((state: RootState) => state.contract)


    const defaulPeriodFrom = moment().add(-10, 'month').format('MM-YYYY')
    const defaulPeriodTo = moment().add(1, 'month').format('MM-YYYY')

    const form: ConsFormType = {
        contract_id: Number(param_contract_id) || 0,
        periodFrom: defaulPeriodFrom,
        periodTo: defaulPeriodTo
    }


    const [sendForm, setSendForm] = useState<ConsFormType>(form);

    // sendForm
    const { currentData, error, isFetching } = useViewConsumptionQuery<any>(sendForm)

    const uniqueKeys = currentData?.legendKeys?.map((i: string) => {
        return ({
            key: i,
            show: true,
        })
    })
    const [legend, setLegend] = useState([]);
    useEffect(() => {
        if (isIterableArray(uniqueKeys) && !isIterableArray(legend)) {
            setLegend(uniqueKeys)
        }
    }, [uniqueKeys, legend]);


    useEffect(() => {
        if (!!activeDateCommon) {
            setFormForFetch(activeDateCommon)
        }
    }, [activeDateCommon]);

    const setFormForFetch = (values: any) => {
        setSendForm(prev => ({
            ...prev, ...{
                ...values,
                contract_id: param_contract_id
            }
        }))
    }

    const handleClick = (index: number, el: any) => {
        const period = currentData?.formatted?.labels?.[index]
        setPeriodMonth(period)
    }

    const datachar = useCallback(
        () => {
            const data = currentData?.formatted
            if (!data) return
            const datasets = []
            if (isData(data.declared) && isShowInLegend(legend, 'declared')) datasets.push({
                animation: false,
                transitions: false,
                order: 1,
                label: t('analytics.declared'),
                data: data.declared,
                data_origin: data.declared_origin,
                backgroundColor: chartColors.declared,
                borderRadius: 4,
                spanGaps: false,
                stack: 'Stack1',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    // rotation: '-90',
                    anchor: 'center',
                    formatter: function (_: any, context: any) {
                        const origin_value = context?.dataset?.data_origin?.[context?.dataIndex]
                        return `${toFormatPrice(origin_value, 3)}`;
                    },
                    textStrokeColor: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return chartColors.declared;
                    },
                    textStrokeWidth: 1,
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#FDFDFD';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }

            })
            if (isData(data.declared_delta_less_6) && isShowInLegend(legend, 'declared_delta_less_6')) datasets.push({
                animation: false,
                transitions: false,
                order: 2,
                label: t('analytics.declared_delta_less_6'),
                data: data.declared_delta_less_6,
                backgroundColor: chartColors.declared_delta_less_6,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack1',
                datalabels: {
                    display: false,
                }
            })
            if (isData(data.declared_delta_more_6) && isShowInLegend(legend, 'declared_delta_more_6')) datasets.push({
                animation: false,
                transitions: false,
                order: 2,
                label: t('analytics.declared_delta_more_6'),
                data: data.declared_delta_more_6,
                backgroundColor: chartColors.declared_delta_more_6,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack1',
                datalabels: {
                    display: false,
                    // display: !isMobile,
                    // align: 'center',
                    // anchor: 'center',
                    // formatter: function (value: any) {
                    //     return `${toFormatPrice(value, 3)}`;
                    // },
                    // color: function (context: any) {
                    //     if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                    //     return '#444248';
                    // },
                    // font: {
                    //     weight: 500,
                    //     size: 10,
                    //     family: 'Inter'
                    // }
                }
            })
            if (isData(data.fact) && isShowInLegend(legend, 'fact')) datasets.push({
                animation: false,
                transitions: false,
                order: 1,
                label: t('analytics.fact'),
                data: data.fact,
                backgroundColor: chartColors.fact,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack2',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    // rotation: '-90',
                    anchor: 'center',
                    formatter: function (value: any) {
                        return `${toFormatPrice(value, 3)}`;
                    },
                    // textStrokeColor: function (context: any) {
                    //     if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                    //     return '#FDFDFD';
                    // },
                    // textStrokeWidth: 1,
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#444248';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }
            })


            if (data) return {
                labels: data?.labels_string,
                datasets: datasets
            }
        },
        [currentData?.formatted, legend],
    )

    const saveExcel = (callback?: any) => {
        axios.post(`${baseApi}/api/analitic/build-excel-report-type-7`, {
            ...sendForm,
            typeReport: 7,
        },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': token,
                }
            })
            .then((response: any) => {
                if (response.data.res === 'Error') {
                    errorToast({
                        title: t('analytics.build_excel_report'),
                        text: t('analytics.build_excel_report_error')
                    })
                }
                else {
                    fileDownload(response.data, `${t('analytics.build_excel_report_7')} ${sendForm.periodFrom} - ${sendForm.periodTo}.xlsx`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('analytics.build_excel_report'),
                    text: t('analytics.build_excel_report_error')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }

    return (
        // ${periodMonth ? 'opacity- 0 hidden' : 'opacity- 1 block'} 
        <div className={`transition-opacity  delay-[150ms] duration-[250ms]`}>
            <FiltersConsumption
                value={{
                    periodFrom: sendForm.periodFrom,
                    periodTo: sendForm.periodTo,
                }}
                isLoadingFetch={isFetching}
                fetchPage={setFormForFetch}
                savePicture={() => {
                    saveGraphToPicture(GRAPH_ID, `${t('or')} ${or_number} - ${t('analytics.analytics_cons_by_period_title')} ${t('by_period')} ${sendForm.periodFrom} - ${sendForm.periodTo}.png`)
                }}
                saveExcel={saveExcel}
                isForSave={!!currentData?.isForSave}
            />
            {

                currentData?.formatted ?
                    <div className='grid lap:grid-cols-[65%_35%] lap2:grid-cols-[75%_25%] gap-[24px] lap:gap-[32px]'>
                        <div className='bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px]'>
                            <Typography variant='lead' className='text-gray-800 text-center mb-[24px] tab:mb-[32px] text-[20px] lap:text-[24px] text-left'>
                                {t('analytics.analytics_cons_by_period_title')}
                            </Typography>
                            <div className={classCharWithDoughtnutContainerHeight}>
                                <GraphConsumption
                                    graphId={GRAPH_ID}
                                    handleClickGraph={handleClick}
                                    datachar={datachar()}
                                    isMobile={isMobile}
                                    fixedCount={3}
                                />
                            </div>
                            {
                                !!currentData?.isForSave &&
                                    (isIterableArray(uniqueKeys) && isIterableArray(legend))
                                    ?
                                    <div className=' mt-[24px] flex gap-[8px] lap:gap-x-[16px] flex-wrap justify-start'>
                                        {
                                            legend.map((item: any, index: number) => (
                                                <div key={index} className='flex gap-[2px] items-center cursor-pointer' onClick={() => {
                                                    setLegend((prev: any) => prev.map((i: any) => ({
                                                        ...i,
                                                        show: item.key === i.key ? !i.show : i.show
                                                    })))
                                                }}>
                                                    <span className={`block rounded w-[10px] h-[10px]  `} style={{ backgroundColor: item.show ? chartColors?.[item.key] : '#eee' }}></span>
                                                    <Typography variant='lead' className={`${item.show ? 'text-gray-700' : 'text-gray-400'}  font-medium text-[12px] lap:text-[14px]`}>
                                                        {t(`analytics.${item.key}`)}
                                                    </Typography>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    :
                                    <div className='min-h-[45px]' />
                            }
                        </div>
                        <div className={`h-full bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] min-h-[400px]`}>
                            <ViewByPeriodDetailing
                                periodFrom={sendForm.periodFrom}
                                periodTo={sendForm.periodTo}
                                graphTarifId={GRAPH_DOUGH_TARIF_ID}
                                graphPriceId={GRAPH_DOUGH_PRICE_ID}
                            />
                        </div>
                    </div>
                    :
                    isFetching ?

                        <div className='grid lap:grid-cols-[65%_35%] lap2:grid-cols-[75%_25%] gap-[24px] lap:gap-[32px]'>
                            <div className={`bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] ${classCharWithDoughtnutContainerHeight} flex justify-center items-center`}>
                                <Spinner />
                            </div>
                            <div className={`h-full bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] min-h-[400px] flex justify-center items-center`}>
                                <Spinner />
                            </div>
                        </div>
                        :
                        error ?
                            <TableLayout>
                                <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                    {t('tables.error_on_loading')}
                                </Typography>
                            </TableLayout>
                            :
                            ''
            }

        </div>
    )
}

export default ViewByPeriod